import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../Header/PageHeader';
import DEFAULT_ROUTES from '../../constants/routes';
import { setActivePage } from '../../features/navigation/navigationSlice';
import NotificationSettingsTable from '../notifications/NotificationSettingsTable';
import { PROJECT_NAV_COPY } from '../notifications/notification.constants';
import styles from './ProjectNotificationSettings.module.scss';

const PAGE_COPY = {
  title: PROJECT_NAV_COPY.projectNotification,
  description: 'Choose how you receive each notification.',
  projectFallback: 'Project',
};

const ProjectNotificationPrefsPage = () => {
  const { selectedProject } = useSelector((state) => state.projects);
  const { activePage } = useSelector((state) => state.navigation);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const projectId = selectedProject?.id;

  const breadcrumbItems = useMemo(() => ([
    {
      label: 'Project',
      onClick: () => {
        dispatch(setActivePage('Projects'));
        navigate(DEFAULT_ROUTES.BASE_URL);
      },
    },
    {
      label: selectedProject?.name || PAGE_COPY.projectFallback,
      onClick: () => {
        dispatch(setActivePage('Test Cases'));
        navigate(`${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}/${projectId}/test-cases`);
      },
    },
    { label: activePage },
  ]), [activePage, dispatch, navigate, projectId, selectedProject?.name]);

  return (
    <div className={styles.page}>
      <PageHeader
        projectName={selectedProject?.name}
        title={PAGE_COPY.title}
        description={PAGE_COPY.description}
        activePage={activePage}
        breadcrumbItems={breadcrumbItems}
        actions={[]}
      />
      <div className={styles.tabContainer}>
        <NotificationSettingsTable projectId={selectedProject?.id} />
      </div>
    </div>
  );
};

export default ProjectNotificationPrefsPage;
